import script from "./ActivityLog.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityLog.vue?vue&type=script&setup=true&lang=js"

import "./ActivityLog.vue?vue&type=style&index=0&id=c8b24578&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8b24578"]])

export default __exports__